import React from 'react';
import { CTAButton } from './CTAButton';
import { CheckIcon } from 'lucide-react';
export function FinalCTA() {
  const mockups = [{
    src: 'https://cdn.magicpatterns.com/uploads/aS8TEinEsRuS6MDLyNf5B7/349bf724-620e-463d-a804-95c66235b1b4.png',
    name: 'Florecer – Guía principal'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/jqoMMD1P1yzQw8rEvpLdJF/2114d6e4-8026-4ff2-bc1e-b7b0b0467235.png',
    name: 'Primeros Auxilios para tu Bebé'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/mqDiGErKSjh21EFDy9aVEX/6e27915d-d49b-4105-b320-286d4047a1c6.png',
    name: 'Carpeta Prenatal Inteligente'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/24xQ36SZ6UXVg394AVD8wU/0db7fcb1-ead9-4325-8a42-110949da6b34.png',
    name: 'Primeras comidas de tu bebé'
  }];
  return <section id="compra" className="w-full bg-sand-100 py-16 md:py-24 px-6" data-id="element-81">
      <div className="max-w-2xl mx-auto text-center flex flex-col items-center" data-id="element-82">
        {/* Title */}
        <h3 className="font-serif text-2xl md:text-3xl text-charcoal-700 mb-7 uppercase tracking-wide" data-id="element-83">
          Florecer incluye:
        </h3>

        {/* Mockup images - 2x2 grid with names */}
        <div className="grid grid-cols-2 gap-5 md:gap-6 mb-8 w-full max-w-lg" data-id="element-84">
          {mockups.map((mockup, index) => <div key={index} className="flex flex-col items-center text-center" data-id="element-85">
              <img src={mockup.src} alt={mockup.name} className="w-32 h-32 md:w-40 md:h-40 object-contain mb-3" data-id="element-86" />
              <div className="flex items-center gap-1.5" data-id="element-87">
                <CheckIcon className="w-4 h-4 text-sage-500 flex-shrink-0" data-id="element-88" />
                <p className="text-charcoal-500 text-xs md:text-sm font-medium leading-tight" data-id="element-89">
                  {mockup.name}
                </p>
              </div>
            </div>)}
        </div>

        <div className="mb-7" data-id="element-90">
          <CTAButton className="px-12 py-5 text-lg" data-id="element-91">
            Acceder a Florecer
          </CTAButton>
        </div>

        <div className="text-charcoal-400 tracking-wider uppercase space-y-2 mb-8" data-id="element-92">
          <p className="text-xl font-medium text-charcoal-600" data-id="element-93">$19.990 ARS</p>
          <p className="text-sm font-light" data-id="element-94">Acceso inmediato</p>
        </div>

        {/* Transfer payment info */}
        <div className="border-t border-charcoal-200/40 pt-6 max-w-md mb-10" data-id="element-95">
          <p className="text-charcoal-500 text-sm md:text-base leading-relaxed mb-3" data-id="element-96">
            Si no contás con tarjeta ni mercado pago, aceptamos transferencia
          </p>
          <p className="text-charcoal-400 text-sm font-light leading-relaxed" data-id="element-97">
            Contactate: soporteaulamater@gmail.com - WhatsApp 1157300315
          </p>
        </div>

        {/* Thank you message + bonus gift */}
        <div className="max-w-md" data-id="element-98">
          <p className="font-serif text-xl md:text-2xl text-charcoal-600 leading-relaxed mb-4" data-id="element-99">
            Gracias por elegirnos en este camino tan especial. Esperamos que se
            cumplan todos tus sueños como mamá.
          </p>
          <p className="font-serif italic text-lg md:text-xl text-warm-500 mb-7" data-id="element-100">
            Te dejamos un regalo más 🎁
          </p>

          <div className="flex flex-col items-center" data-id="element-101">
            <img src="https://cdn.magicpatterns.com/uploads/rLtQv1MHyE5FhEicuL663a/12f8b7c0-4fa2-4221-9582-d307a1c6319d.png" alt="Recuperá tu cuerpo después del embarazo" className="w-[300px] h-[300px] object-contain mb-6" data-id="element-102" />
            <h3 className="font-serif text-xl text-charcoal-700 mb-3 flex items-center justify-center gap-2" data-id="element-103">
              <span data-id="element-104">💪</span> Recuperá tu cuerpo después del embarazo
            </h3>
            <p className="text-charcoal-400 font-light px-4" data-id="element-105">
              Para volver a sentirte vos, cuidar tu cuerpo y transitar el
              postparto con calma y sin exigencias
            </p>
          </div>
        </div>
      </div>
    </section>;
}